// extracted by mini-css-extract-plugin
export default {"container":"notification_container__ERIZp"};